<template>
    <v-dialog v-model="exibirMensagem" :max-width="Modal.Processamento.larguraMaxima">
        <v-card :max-width="Modal.Processamento.larguraMaxima" :min-width="Modal.Confirmacao.larguraMinima">
            <v-card-title class="modal_title primary white--text py-0" primary-title dark>
                <span>{{ titulo }}</span>
                <v-spacer></v-spacer>
                <v-btn color="white" small icon flat @click="$emit('recusado')">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>

            <v-card-text class="">
                <h4 v-show="textoPrimario" class="mb-2 text--secondary">
                    <strong>{{ textoPrimario }}</strong>
                </h4>

                <v-list  v-show="textoSecundario.length > 0" class="mensagem-confirmacao__texto-secundario text-com-lista">
                    <v-list-tile v-for="(item, index) in textoSecundario" :key="index" class="item-lista">
                      - {{item}}
                    </v-list-tile>
                </v-list>
            </v-card-text>

            <v-card-actions class="px-3 py-2">
                <v-btn id="botaoRecusar" @click="$emit('recusado')" flat outline color="botao-cancelar-color">
                    {{ botaoRecusar }}
                </v-btn>
                <v-spacer></v-spacer>
                <v-btn id="botaoConfirmar" @click="$emit('confirmado')" depressed color="primary">
                    {{ botaoConfirmar }}
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { Modal } from '@/core/constants'

export default {
    name: 'MensagemConfirmacaoComLista',
    props: {
        exibirMensagem: {
            type: Boolean,
            default: false
        },
        titulo: {
            type: String,
            default: 'Confirmação'
        },
        textoPrimario: {
            type: String,
            default: ''
        },
        textoSecundario: {
            type: Array,
            default: () => []
        },
        botaoRecusar: {
            type: String,
            default: 'Não'
        },
        botaoConfirmar: {
            type: String,
            default: 'Sim'
        },
        tamanhoMaximo: {
            type: String,
            default: '400'
        }
    },
    data() {
        return {
            Modal
        }
    }
}
</script>

<style scoped lang="stylus">
    .mensagem-confirmacao
        &__texto
            color #555

        &__texto-secundario
            text-align left !important

    .text-com-lista .item-lista
        font-style italic
</style>